import React, { useState } from 'react';
import { useAuth } from '../lib/auth';
import { Navigate, useSearchParams } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';

export default function Login() {
  const { user, login, loading } = useAuth();
  const [params] = useSearchParams();
  const expired = params.get('expired') === '1';
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  if (loading) return <div className="min-h-screen flex items-center justify-center text-zinc-500">Chargement…</div>;
  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email.trim(), password);
      toast.success('Bienvenue');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Échec de connexion');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white">
      <div className="hidden lg:flex items-center justify-center bg-zinc-50 border-r border-zinc-200 relative overflow-hidden">
        <div className="blueprint-grid absolute inset-0 opacity-60" />
        <div className="relative z-10 flex flex-col items-center">
          <img src="/assets/logo-mn.png" alt="MN Architecture" className="h-48 w-auto mb-8 grayscale" data-testid="login-logo" />
          <div className="text-center">
            <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-2">Outil de pilotage</div>
            <div className="font-display font-bold text-3xl tracking-tight">ATELIER MN ARCHITECTURE</div>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5" data-testid="login-form">
          <div className="mb-8">
            <img src="/assets/logo-mn.png" alt="MN" className="h-14 w-auto mb-4 lg:hidden" />
            <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-1">Connexion</div>
            <h1 className="font-display font-bold text-3xl tracking-tighter">Bienvenue</h1>
            <p className="text-sm text-zinc-500 mt-2">Accédez à votre espace de pilotage.</p>
          </div>
          {expired && (
            <div className="bg-amber-50 border border-amber-300 text-amber-900 text-xs px-3 py-2.5" data-testid="login-expired-banner">
              Votre session a expiré. Merci de vous reconnecter.
            </div>
          )}
          <div>
            <Label htmlFor="email" className="text-[10px] uppercase tracking-[0.15em]">Email</Label>
            <Input id="email" type="email" required className="rounded-none h-11" value={email}
                    onChange={(e) => setEmail(e.target.value)} autoFocus autoComplete="username"
                    data-testid="login-email" />
          </div>
          <div>
            <Label htmlFor="password" className="text-[10px] uppercase tracking-[0.15em]">Mot de passe</Label>
            <Input id="password" type="password" required className="rounded-none h-11" value={password}
                    onChange={(e) => setPassword(e.target.value)} autoComplete="current-password"
                    data-testid="login-password" />
          </div>
          <Button type="submit" disabled={busy} className="w-full rounded-none h-11 bg-[#002FA7] hover:bg-[#001B63]" data-testid="login-submit">
            {busy ? 'Connexion…' : 'Se connecter'}
          </Button>
        </form>
      </div>
    </div>
  );
}
